import getFormattedAmount from './getFormattedAmount';
import React from 'react';
import getAccountBonusByPeriod from './getAccountBonusByPeriod';

/**
 * Formats label period discount label for a selector.
 *
 * @param {string} label
 * @param {object} period
 * @param {string} currency
 * @return {Element}
 */
export default (label, period, currency) => {
    let discount = period?.discount
        ? getFormattedAmount(period?.discount, '(<value:auto> Off)', {
              unit: period?.unit?.toUpperCase(),
              currency: currency,
          })
        : '';
    const accountBonusPeriod = getAccountBonusByPeriod(period);
    if (accountBonusPeriod) {
        discount += ` + ${accountBonusPeriod.label}`;
    }
    return (
        <>
            {' '}
            {label} <span className={'filter-label__discount'}> {discount} </span>{' '}
        </>
    );
};
